import { useTranslation } from "@next-platform/client-common-core";
import { useCallback } from "react";
import { useInstantSearch } from "react-instantsearch";

import AppliedFiltersBarView from "./AppliedFiltersBarView";
import useFiltersV2State from "./useFiltersV2State";

const AppliedFiltersBarCharacter = () => {
  const { results } = useInstantSearch();
  const { t } = useTranslation();
  const { chips, hasAppliedFilters, removeChip, clearAll } = useFiltersV2State();
  const count = results?.nbHits ?? 0;
  const processingTimeMS = results?.processingTimeMS ?? 0;
  const resultCountText = t("search:web.results.found", { count, processingTimeMS });
  const getRemoveAriaLabel = useCallback((label: string) => t("chatbotFilters:appliedFilters.removeFilter", { label }), [t]);
  const clearAllLabel = t("chatbotFilters:appliedFilters.clearAll");

  return (
    <AppliedFiltersBarView
      chips={chips}
      clearAllLabel={clearAllLabel}
      getRemoveAriaLabel={getRemoveAriaLabel}
      hasAppliedFilters={hasAppliedFilters}
      onClearAll={clearAll}
      onRemoveChip={removeChip}
      resultCountText={resultCountText}
    />
  );
};

export default AppliedFiltersBarCharacter;
